import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import { isEmpty, mapKeys } from 'lodash';
import { getAreaUnit, getDistanceUnit, formatTableValueUnit } from '@/utils';
import { aggregateFriendlyName, nonAggregateFriendlyName } from './tableColumns';

const getFriendlyName = (isAggregateTable, areaMetrics, distanceMetrics, units) => (_, asset) => {
  const text = isAggregateTable ? aggregateFriendlyName(asset) : nonAggregateFriendlyName(asset);
  if (text) {
    return text;
  }

  if (areaMetrics.includes(asset)) {
    return `${asset} (${getAreaUnit(units)})`;
  }
  if (distanceMetrics.includes(asset)) {
    return `${asset} (${getDistanceUnit(units)})`;
  }
  return asset;
};

const computedCsvData = (isAggregateTable, computedTableRes, areaMetrics, distanceMetrics, units) =>
  // remove some cols and format csv headers
  computedTableRes.map(({ equipment_id: _equipmentID, inspection_uuid: _inspectionUUID, type: _type, ...row }) =>
    mapKeys(
      {
        ...row,
        images: row.images.map((image) => image.image_name),
      },
      getFriendlyName(isAggregateTable, areaMetrics, distanceMetrics, units)
    )
  );

const computeTableValueUnit = (areaMetrics, distanceMetrics, units, table) =>
  table.map(formatTableValueUnit(distanceMetrics, areaMetrics, units)).filter((x) => !isEmpty(x));

export const exportTableAsCSV = (isAggregateTable, tableRes, areaMetrics, distanceMetrics, units) => {
  if (tableRes) {
    const computedTableRes = computeTableValueUnit(areaMetrics, distanceMetrics, units, tableRes);
    const x = Papa.unparse(computedCsvData(isAggregateTable, computedTableRes, areaMetrics, distanceMetrics, units));
    const blob = new Blob([x], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'export.csv');
  }
};
